import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithReauth } from './utils';

export const utilitiesApi = createApi({
  reducerPath: 'utilitiesApi',
  baseQuery: baseQueryWithReauth,
  endpoints: (build) => ({
    getUtilities: build.query({
      query: (params: {
                page: number;
                limit: number;
            }) => ({
        url: 'utility/get-utilities',
        method: 'POST',
        body: {
          ...params,
        },
      }),
    }),
  }),
});

export const {
  useGetUtilitiesQuery,
} = utilitiesApi;